import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// const CreateIssue = Loadable(lazy(() => import('pages/create_issue')));
// const ListIssue = Loadable(lazy(() => import('pages/list_issue')));
const TempoAccounts = Loadable(lazy(() => import('pages/tempo')));
const Account = Loadable(lazy(() => import('pages/account')));
const Worklogs = Loadable(lazy(() => import('pages/worklogs')));
const Dashbaord = Loadable(lazy(() => import('pages/dashboard')));
const History = Loadable(lazy(() => import('pages/history')));

// const DashboardPage = Loadable(lazy(() => import('pages/dashboard/default')));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        // {
        //   path: "dashboard",
        //   children: [
        //     {
        //       path: "default",
        //       element: <DashboardDefault />,
        //     },
        //     {
        //       path: "analytics",
        //       element: <DashboardAnalytics />,
        //     },
        //   ],
        // },
        // {
        //   path: '/',
        //   element: <CreateIssue />,
        // },
        // {
        //   path: "dashboard",
        //   element: <DashboardPage />,
        //   rights: "ngtRequest",
        // },
        // {
        //   path: 'overview',
        //   element: <CreateIssue />,
        //   rights: 'ngtRequest',
        // },
        // {
        //   path: 'list-issues',
        //   element: <ListIssue />,
        //   rights: 'ngtTemplate',
        // },
        {
          path: 'accounts',
          element: <TempoAccounts />,
          rights: 'ngtTemplate',
        },
        {
          path: 'accounts/:name',
          element: <Account />,
          rights: 'ngtTemplate',
        },
        {
          path: 'accounts/:name/:month',
          element: <Worklogs />,
          rights: 'ngtTemplate',
        },
        
        {
          path: 'dashboard',
          element: <Dashbaord />,
          rights: 'ngtTemplate',
        },
        {
          path: 'log',
          element: <History />,
          rights: 'ngtTemplate',
        },
        // {
        //   path: '*',
        //   element: <CreateIssue />,
        //   rights: 'ngtRequest',
        // },
      ],
    },
    // {
    //   path: "/maintenance",
    //   element: <CommonLayout />,
    //   children: [
    //     {
    //       path: "404",
    //       element: <MaintenanceError />,
    //     },
    //     {
    //       path: "500",
    //       element: <MaintenanceError500 />,
    //     },
    //     {
    //       path: "under-construction",
    //       element: <MaintenanceUnderConstruction />,
    //     },
    //     {
    //       path: "coming-soon",
    //       element: <MaintenanceComingSoon />,
    //     },
    //   ],
    // },
    // {
    //   path: "/auth",
    //   element: <CommonLayout />,
    //   children: [
    //     {
    //       path: "login",
    //       element: <AuthLogin />,
    //     },
    //     {
    //       path: "register",
    //       element: <AuthRegister />,
    //     },
    //     {
    //       path: "forgot-password",
    //       element: <AuthForgotPassword />,
    //     },
    //     {
    //       path: "reset-password",
    //       element: <AuthResetPassword />,
    //     },
    //     {
    //       path: "check-mail",
    //       element: <AuthCheckMail />,
    //     },
    //     {
    //       path: "code-verification",
    //       element: <AuthCodeVerification />,
    //     },
    //   ],
    // },
  ],
};

export default MainRoutes;
